import { Dialog, Transition } from '@headlessui/react';
import { motion } from 'framer-motion';
import { Fragment, useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';

interface ModalProps {
  loading: boolean;
}

export const LoadingModal = ({ loading }: ModalProps) => {
  const [open, setOpen] = useState(true);
  const barRef = useRef(null);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && open) {
        setOpen(false);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open]);

  useEffect(() => {
    if (loading) {
      setOpen(true);
      return;
    }
    if (!!!loading) {
      setOpen(false);
    }
  }, [loading]);

  return (
    <Transition show={open} as={Fragment}>
      <Dialog
        as="div"
        id="modal"
        className="fixed inset-0 z-10 overflow-y-auto"
        initialFocus={barRef}
        open={open}
        onClose={() => setOpen(false)}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100 "
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 backdrop-filter backdrop-blur-sm" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-md align-middle transition-all transform bg-white shadow-xl rounded-2xl focus:outline-none">
              <div className="px-12 py-10">
                <p className="text-center text-gray-400">
                  Please wait while we crunch the numbers on product relations
                  combinations...
                </p>

                <div className="relative h-1 mt-5">
                  <div className="absolute w-full h-full bg-gray-200" />
                  <motion.div
                    ref={barRef}
                    id="bar"
                    initial={{ width: '0' }}
                    animate={{ width: '98%' }}
                    transition={{ duration: 10 }}
                    className="relative h-full font-bold bg-segments-accent-color-1"
                  />
                </div>
                <p className="mt-2 text-center text-segments-accent-color-1">
                  <CountUp
                    duration={10}
                    start={0}
                    end={98}
                    useEasing={false}
                    formattingFn={(value) => `${value}%`}
                  />
                </p>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
